export default {
  message: {
    ABOUT_THE_COMPANY: "About the insurer",
    ADD_TO_FAVORITES: "Save as favorite",
    TARIFF_MARK_BOOKMARK: "Mark",
    TARIFF_MARK_BOOKMARKED: "Marked",
    TARIFF_MARK_ADD_NOTE: "Add note",
    TARIFF_MARK_NOTE_PLACEHOLDER: "Note about this tariff …",
    TARIFF_MARK_NOTE: "Note",
    TARIFF_MARK_NOTE_TITLE: "Note for this tariff",
    TARIFF_MARK_NOTE_SAVE: "Save",
    TARIFF_MARK_NOTE_REMOVE: "Remove note",
    TARIFF_MARK_NOTE_EDIT: "Edit",
    TARIFF_MARK_SEND_OFFER: "Send marked as offer",
    TARIFF_MARK_SEND_OFFER_SHORT: "Send offer",
    TARIFF_SIDE_RAIL_TOOLTIP_BOOKMARK: "Select tariff for an offer",
    TARIFF_SIDE_RAIL_TOOLTIP_BOOKMARKED: "Remove selection",
    TARIFF_SIDE_RAIL_TOOLTIP_NOTE: "Add a note to the selected tariff",
    TARIFF_SIDE_RAIL_TOOLTIP_NOTE_EDIT: "Edit note for the selected tariff",
    TARIFF_SIDE_RAIL_TOOLTIP_COMPARE: "Add tariff to comparison",
    TARIFF_SIDE_RAIL_TOOLTIP_COMPARE_REMOVE: "Remove tariff from comparison",
    TARIFF_SIDE_RAIL_TOOLTIP_PRINT: "Print tariff",
    TARIFF_SIDE_RAIL_TOOLTIP_CONTACTS: "Show contacts for this tariff",
    ADDITIONAL_FILTERS: "Additional filters",
    ACCEPT: "Accept",
    ADDRESS_ERROR_MESSAGE: "Street name and number are required",
    ADDRESS_HOUSE_NUMBER_FORMAT_INVALID: "The house number format is invalid",
    ADDRESS_SEARCH_PLACEHOLDER: "Search…",
    ADDRESS_STREET_NUMBER_PLACEHOLDER: "No.",
    ADDRESS_STREET_SELECT_FROM_LIST:
      "Please select the street from the suggestion list.",
    ADDRESS_VALIDATION_FAILED_CONTACT:
      "We could not validate the address entered. Please try again or contact {supportEmail}",
    ADDRESS_SECTION: "Address",
    ADD_TARIFF: "Add product",
    A11Y_TARIFF_BROKER_ACTIONS: "Broker actions for tariff",
    A11Y_TARIFF_SIDE_RAIL: "Actions for this tariff",
    A11Y_STATEMENT_CONFORMANCE_BODY:
      "This web application aims to conform with WCAG 2.2 Level AA. Implementation is ongoing; known limitations are listed below.",
    A11Y_STATEMENT_CONFORMANCE_HEADING: "Conformance status",
    A11Y_STATEMENT_ENFORCEMENT_BODY:
      "If you are not satisfied with our response, you may contact the enforcement body under the German Accessibility Strengthening Act.",
    A11Y_STATEMENT_ENFORCEMENT_HEADING: "Enforcement procedure",
    A11Y_STATEMENT_FEEDBACK_BODY:
      "If you encounter barriers, please email us at",
    A11Y_STATEMENT_FEEDBACK_HEADING: "Feedback and contact",
    A11Y_STATEMENT_FEEDBACK_SUBJECT: "Accessibility feedback – {brandName}",
    A11Y_STATEMENT_INTRO:
      "{brandName} strives to make the calculator and application journeys accessible. This statement was published on {assessedDate}.",
    A11Y_STATEMENT_LIMITATION_ADS:
      "Embedded advertisements and third-party content may have accessibility barriers.",
    A11Y_STATEMENT_LIMITATION_CHAT:
      "Optional live chat (Freshchat) is provided by a third party.",
    A11Y_STATEMENT_LIMITATION_THIRD_PARTY:
      "White-label embeds may show different header, footer, and help elements.",
    A11Y_STATEMENT_LIMITATIONS_HEADING: "Known limitations",
    A11Y_STATEMENT_SCOPE_BODY:
      "In scope: tariff search, needs wizard, comparison, application (checkout), and email verification in this app.",
    A11Y_STATEMENT_SCOPE_HEADING: "Scope",
    A11Y_STATEMENT_TITLE: "Accessibility statement",
    ALPHA_ASC: "A to Z",
    ALPHA_ASC_MOBILE: "Insurer (A to Z)",
    ALPHA_DESC: "Z to A",
    ALPHA_DESC_MOBILE: "Insurer (Z to A)",
    ALPHA_MAIN_LABEL: "Insurer",
    ANNUAL_FEE: "Annual premium",
    APP_POPUP_DEFAULT_TITLE: "Notice",
    APP_POPUP_DISMISS_DEFAULT: "OK",
    APP_POPUP_NO_CONTENT: "No content available.",
    APP_TOAST_CLIPBOARD_TARIFF_FALLBACK: "Product: ({legacyId})",
    APP_TOAST_CLIPBOARD_TARIFF_LINE: "Product: {main} ({legacyId})",
    APP_TOAST_CLIPBOARD_TOKEN_LINE: "Token: {token}",
    APP_TOAST_CLIPBOARD_URL_LINE: "Page URL: {url}",
    APP_TOAST_CONSOLE_SECTION_HEADER:
      "--- Recent console output (errors / warnings) ---",
    APP_TOAST_COPIED: "Copied",
    APP_TOAST_COPY_ERROR: "Copy error message",
    APP_TOAST_EMAIL_REPORT: "Send error report by email",
    APP_TOAST_EMAIL_SUBJECT: "Booking error report",
    APP_TOAST_SESSION_ID_LABEL: "Session ID:",
    APP_TOAST_TITLE_ERROR: "Error",
    APP_TOAST_TITLE_INFO: "Information",
    APP_TOAST_TITLE_SUCCESS: "Success",
    APP_TOAST_TITLE_WARNING: "Notice",
    APPLY_CHANGES: "Apply changes",
    ARIA_LABEL_CLOSE: "Close",
    ARIA_LABEL_CLEAR_FIELD: "Clear input",
    AWARDS: "Awards",
    BACK: "Back",
    BACK_TOP_TOP: "Back to top",
    BACK_TO_SEARCH: "Back to search",
    BEST_RATING: "Top rated",
    BOOK: "Apply now",
    BOOK_SHORT: "Apply",
    BOOKING_SUMMARY_EMAIL_VERIFICATION_TITLE: "One more step",
    BOOKING_SUMMARY_EMAIL_VERIFICATION_NOTICE:
      "After you click <strong>“{cta}”</strong>, we will send an email to <strong>{email}</strong>. Click the link in that email to complete your application.<br/><br/><strong>Tip:</strong> Please also check your spam folder if needed. The email address cannot be changed later — make sure you have access to this inbox.",
    INVITATIO_BOOKING_SUMMARY_EMAIL_VERIFICATION_NOTICE:
      "After you click <strong>“{cta}”</strong>, we will send an email to <strong>{email}</strong>. Click the link in that email to complete your request.<br/><br/><strong>Tip:</strong> Please also check your spam folder if needed. The email address cannot be changed later — make sure you have access to this inbox.",
    VERIFICATION_EMAIL_ADDRESS_LOCKED_NOTE:
      "The verification email was sent to <strong>{email}</strong>. This address can no longer be changed.",
    BOOKING_COMPLETED_INFO_1: `Your insurance application has been received. You will shortly receive a confirmation email at <strong>{email}</strong>.
      If you do not see it, please check your spam folder.`,
    BOOKING_COMPLETED_INFO_2:
      "Please note that cover does not take effect until <strong>{name}</st rong> has accepted your application and the initial premium has been paid.",
    BOOKING_COMPLETED_INFO_4:
      "Your application is stored in our system under the reference below. Please cite this reference whenever you contact us.",
    BOOKING_COMPLETED_INFO_5:
      "Below you will find the documents you need for your application and other helpful links. Please note that your insurance documents will be issued directly by the insurer.",
    BOOKING_COMPLETED_INFO_5_NO_SERVICE_APP:
      "Below you will find the documents you need for your application. Please note that your insurance documents will be issued directly by the insurer.",
    BOOKING_COMPLETED_PROTOCOL_LINK_LABEL: "Download {documentName}",
    BOOKING_COULD_NOT_COMPLETE_RETRY:
      "The booking could not be completed. Please try again.",
    BOOKING_SESSION_ALREADY_CONFIRMED:
      "Your application has already been received. You do not need to submit it again.",
    BOOKING_SESSION_ALREADY_CONFIRMED_WITH_ID:
      "Your application has already been received. You do not need to submit it again. Booking ID: A-{bookingId}",
    BOOKING_EMAIL_FIELD_VALIDATION_FAILED:
      "We could not validate the email address. Please use a different address or contact us at {supportEmail}",
    BOOKING_ENTITY_ADD: "+ Add {unit}",
    BOOKING_ENTITY_REMOVE: "Remove {unit} {n}",
    BOOKING_FOOTER_BADGE_SUBJECT_TO_INQUIRY: "Inquiry required",
    BOOKING_FOOTER_BOOK_BUTTON_INQUIRY_PAID: "Submit paid inquiry",
    BOOKING_FOOTER_BOOK_BUTTON_INQUIRY_SUBMIT: "Submit inquiry",
    BOOKING_FOOTER_PRICE_ON_REQUEST: "On request",
    BOOKING_LOADING_INSURED_PERSONS: "Loading insured persons…",
    BOOKING_TRANSITION_LOADING: "Loading the form…",
    BOOKING_TRANSITION_LOADING_QUOTE: "Loading your quote request…",
    BOOKING_TRANSITION_SUBMITTING: "Your data is being submitted…",
    SEARCH_RESULTS_LOADING: "Loading search results…",
    BOOKING_NETWORK_UNCERTAINTY_TOAST:
      "The connection was interrupted. If your application was successful, you will find the confirmation on the next page. Please verify.",
    BOOKING_PAGE_ONE_HEADING: "Your details",
    BOOKING_SHUFFLE_ARIA: "Fill application form fields with random data",
    BOOKING_SHUFFLE_LABEL: "Fill fields randomly",
    BOOKING_SHUFFLE_CHECKBOXES_ARIA:
      "Check all required checkboxes on the application page",
    BOOKING_SHUFFLE_CHECKBOXES_LABEL: "Check required checkboxes",
    BOOKING_SHUFFLE_OPTIONS_ARIA: "Special cases for random fill",
    BOOKING_SHUFFLE_OPTION_POLICYHOLDER_ADULT: "Policyholder (adult)",
    BOOKING_SHUFFLE_OPTION_ALTERNATIVE_PAYER: "Alternative payer",
    BOOKING_PAGE_VALIDATION_UNAVAILABLE:
      "Validation could not be completed. Please try again.",
    BOOKING_REFERENCE_PENDING: "Being created",
    BOOKING_TOAST_JUMP_TO_FIRST_ERROR: "Go to the first error",
    BOOKING_VALIDATION_FAILED_WITH_SUPPORT:
      "Validation failed. Please try again or contact support.",
    BOOK_ANOTHER_CONTRACT: "Submit another application",
    BOOK_LAST_PAGE: "Submit application (binding)",
    BROKER_ACCOUNT_SUSPENDED_BODY:
      "This intermediary account is not recognised by us or has been deactivated. Please contact your intermediary or email {supportEmail}.",
    BROKER_ACCOUNT_SUSPENDED_TITLE:
      "This intermediary account has been suspended",
    BROKER_CTA_HOLD_TOOLTIP:
      "Please enter your broker details first, so that you can continue.",
    CALCULATOR_NOTE_LINK_TEXT: "Disclosures and participating insurers",
    CANCEL: "Cancel",
    CANCEL_BUTTON: "Cancel",
    CHECKING_CONTRACT:
      "We are reviewing your application and forwarding it to the selected insurer.",
    CLEAR_ALL: "Clear all",
    CONTRACT_CANCELLATION: "Withdraw from contract",
    COMPANIES: "Insurers",
    INSURER_TEASER_ARIA: "Insurers with starting price",
    INSURER_TEASER_SCROLL_LEFT: "Scroll insurers left",
    INSURER_TEASER_SCROLL_RIGHT: "Scroll insurers right",
    TARIFF_DETAILS_TABS_SCROLL_LEFT: "Scroll product details left",
    TARIFF_DETAILS_TABS_SCROLL_RIGHT: "Scroll product details right",
    COMPARISON_PAYMENT_OPTIONS_GENERIC_ERROR:
      "Payment options could not be loaded.",
    COMPARISON_PAYMENT_OPTIONS_LABEL: "Available payment options",
    COMPARISON_PAYMENT_OPTIONS_NOT_AVAILABLE: "Not available",
    COMPARISON_PAYMENT_OPTIONS_RETRY: "Retry",
    COMPARISON_PAYMENT_OPTIONS_TIMEOUT_ERROR:
      "Payment options could not be loaded (request timed out). Please try again.",
    COMPARISON_PAYMENT_SELECTED_LABEL: "Price for selected payment interval",
    COMPARISON_PRODUCT_HIGHLIGHTS: "Highlights",
    COMPARISON_REMOVE_TARIFF: "Remove product from comparison",
    CONTACT_LINK_TXT: "Contact",
    CONTINUE: "Continue",
    CONTRACT_DONE: "We have received your application",
    CONTRACT_DONE_TARIFF_INFO_TITLE: "Cover you applied for",
    CONTRACT_PROCESSING: "Application processing",
    CONTRACT_PROCESSING_TEXT: "The insurer is processing your application.",
    CONTRACT_RENEWAL_APPLICATION_NUMBER_LABEL: "Application number",
    CONTRACT_RENEWAL_APPLICATION_NUMBER_PLACEHOLDER: "e.g. 123456",
    CONTRACT_RENEWAL_BIRTH_DATE_LABEL: "Date of birth",
    CONTRACT_RENEWAL_CONTINUE: "Continue",
    CONTRACT_RENEWAL_INFORMATIVE:
      "I confirm that I have downloaded and read the initial disclosure for insurance intermediaries pursuant to § 15 VersVermV (German law). {link}",
    CONTRACT_RENEWAL_INFORMATIVE_REQUIRED:
      "Please confirm that you have received the initial disclosure.",
    CONTRACT_RENEWAL_INTRO:
      "To continue, please enter the application number, date of birth and postal code of the policyholder whose contract you wish to renew.",
    CONTRACT_RENEWAL_INVALID_APPLICATION_NUMBER:
      "Please enter a valid application number.",
    CONTRACT_RENEWAL_INVALID_POSTAL_CODE: "Invalid postal code",
    CONTRACT_RENEWAL_LOADER_STEP_PREPARE: "Loading tariff calculator",
    CONTRACT_RENEWAL_LOADER_STEP_READY: "Redirecting to tariff search",
    CONTRACT_RENEWAL_LOADER_STEP_VERIFY: "Confirming application",
    CONTRACT_RENEWAL_LOADER_SUBTITLE: "Please wait a moment.",
    CONTRACT_RENEWAL_LOADER_TITLE: "Your contract is being prepared",
    CONTRACT_RENEWAL_POSTAL_CODE_LABEL: "Postal code",
    CONTRACT_RENEWAL_POSTAL_CODE_PLACEHOLDER: "e.g. 60327",
    CONTRACT_RENEWAL_TITLE: "Confirmation required",
    CONTRACT_SUBMISSION: "Application submitted",
    CORONA_CANCELLATION_DAFAULT_TOOLTIP:
      "<b>Trip cancellation / curtailment</b><br>With this product, you or the insured person are covered if you test positive for COVID-19 before departure and can provide proof. Fear of travel or infection alone is not covered.",
    CORONA_HEALTH_DAFAULT_TOOLTIP:
      "<b>Travel medical</b><br>With this product, you are covered if you become ill with COVID-19 during your trip and require medical treatment. Additional costs due to quarantine (e.g. accommodation) are not covered.",
    CORONA_INSURED: "COVID-19 covered",
    CORONA_NOT_INSURED: "COVID-19 not covered",
    CORONA_PARTIALLY_INSURED: "Review COVID-19 notice",
    CORONA_TAG_HEADING_CANCEL: "Trip cancellation / curtailment",
    CORONA_TAG_HEADING_HEALTH: "Travel medical",
    COVERAGE_FEATURES: "Coverage features",
    DATA_PROTECTION: "Privacy",
    DOCUMENTS: "Documents",
    DOCUMENTS_LOADING: "Loading documents…",
    DOWNLOAD: "Download",
    DOWNLOAD_ALL: "Download all documents as a ZIP file",
    DOWNLOAD_PROTOCOL: "Download advisory record",
    EMAIL_ADDRESS: "Email address",
    EMAIL_ADDRESS_OF_THE_RECIPIENT: "Recipient",
    CC: "IN COPY",
    EMAIL_FORM_PLACEHOLDER: "max.mustermann{'@'}example.com",
    EMAIL_FORM_CC_HELPER: "Confirm multiple addresses with Enter",
    EMAIL_FORM_CC_PLACEHOLDER: "Add one or more email addresses…",
    EMAIL_FORM_FIELD_EMAIL: "Email",
    EMAIL_FORM_MESSAGE_LABEL: "Message",
    EMAIL_IS_REQUIRED: "Email is required",
    ENTER_CORRECT_EMAIL: "Please enter a valid email address",
    FILE_UPLOAD: "Choose file",
    FILE_UPLOAD_SMARTPHONE: "Upload with smartphone",
    FILE_UPLOAD_SMARTPHONE_TITLE: "Upload document with smartphone",
    FILE_UPLOAD_SMARTPHONE_DESCRIPTION:
      "Scan the QR code with your smartphone camera. The mobile page opens this exact upload field; no login is required.",
    FILE_UPLOAD_SMARTPHONE_ACTIVE: "Active · {time} min. remaining",
    FILE_UPLOAD_SMARTPHONE_ACTIVE_SECONDS: "Active · {time} sec. remaining",
    FILE_UPLOAD_SMARTPHONE_EXPIRED: "QR code expired",
    FILE_UPLOAD_SMARTPHONE_CLOSE: "Close QR code",
    FILE_UPLOAD_SMARTPHONE_REFRESH: "Refresh QR code",
    FILE_UPLOAD_SMARTPHONE_WAITING: "Waiting for smartphone upload…",
    FILE_UPLOAD_SMARTPHONE_UPLOADED: "Uploaded via smartphone",
    FILE_UPLOAD_SMARTPHONE_SUCCESS_TITLE: "Document uploaded successfully",
    FILE_UPLOAD_SMARTPHONE_UPLOADED_AT: "Uploaded on {date}",
    FILE_UPLOAD_SMARTPHONE_FILE_SIZE: "File size: {size}",
    FILE_UPLOAD_SMARTPHONE_REPLACE: "Replace",
    FILE_UPLOAD_REMOVE: "Remove file {fileName}",
    FILE_UPLOAD_SUCCESS: "File {fileName} uploaded successfully",
    FILE_ERROR_MAX_COUNT:
      "A maximum of {count} file can be uploaded. | A maximum of {count} files can be uploaded.",
    FILE_ERROR_SIZE:
      "The selected file is too large. Maximum size: {maxSizeMb} MB.",
    FILE_ERROR_FORMAT:
      "This file format is not supported. Allowed file types: {allowedTypes}.",
    FILTERS: "Filters",
    FILTER_ACTION: "Filter",
    FILTER_BY: "Filter by:",
    CLEAR: "Clear",
    LINKS: "Links",
    RESULTS_CONTROLS_TOOLBAR: "Sort and filter results",
    FOOTER_AGB_LINK: "Terms",
    FOOTER_COOKIES_LINK: "Cookies",
    FOOTER_COPYRIGHT: "© {brandName}",
    FOOTER_MORE_LINKS: "More links",
    FORM_CONTAINS_ERRORS_TEXT:
      "The form contains errors. Please correct them before continuing.",
    BOOKING_FOOTER_ERROR_HINT_TOOLTIP:
      "There are errors in the form. Click here to jump to the first error.",
    BOOKING_FOOTER_ERRORS_FOUND_ONE: "1 error found",
    BOOKING_FOOTER_ERRORS_FOUND_MANY: "{count} errors found",
    BOOKING_FOOTER_LANDMARK_LABEL: "Tariff and application navigation",
    EARLIEST_POSSIBLE_START: "earliest possible start",
    EARLIEST_POSSIBLE: "earliest possible",
    FROM: "from",
    FULLY_CONTAINED: "Included",
    GENERAL_BOOKING_ERROR:
      "An error occurred while submitting your information.",
    GET_QUOTES_NOW: "Get quotes now",
    GROUP_TRAVEL_AGE_GROUPS_TOOLTIP:
      "Group travel products apply to groups of 10–150 travellers (6–150 on rail trips). Enter travellers by age.<br> Use each person’s <u>age when you take out cover.</u>",
    IBAN_VALIDATION_FAILED: "Please enter a valid IBAN",
    R_PARAMETER_VALIDATION_EMPTY:
      "The affiliate parameter is missing. Please check the link.",
    R_PARAMETER_VALIDATION_INVALID_FORMAT:
      "The affiliate parameter has an invalid format. Please check the link.",
    R_PARAMETER_VALIDATION_INACTIVE_AFFILIATE:
      "The affiliate is no longer active. Please check the link.",
    R_PARAMETER_VALIDATION_LOOKUP_FAILED:
      "The affiliate could not be found. Please check the link.",
    R_PARAMETER_VALIDATION_PROCESSING:
      "The affiliate parameter could not be processed. Please try again.",
    R_PARAMETER_VALIDATION_RAW_AFFILIATE_ID:
      "The affiliate was resolved using a raw identifier. You can continue — your booking is not blocked.",
    R_PARAMETER_VALIDATION_FAILED:
      "The affiliate parameter is invalid. Please check the link.",
    IMPORTANT_INFORMATION: "Important information",
    IMPORTANT_NOTES: "Important notices",
    IMPORTANT_NOTICE: "Important notice",
    IMPORTANT_PRE_REQUIREMENTS: "Special prerequisites",
    IMPRINT: "Legal notice",
    INACTIVE_TARIFFS_LEARN_MORE: "Learn more…",
    INACTIVE_TARIFFS_MODAL_TITLE: "Temporarily unavailable products",
    INACTIVE_TARIFFS_NOTICE_MULTIPLE:
      "Note: {count} products are unavailable temporarily.",
    INACTIVE_TARIFFS_NOTICE_SINGLE:
      "Note: One product is unavailable temporarily.",
    INFO: "Info",
    CONTACTS: "Contacts",
    INFO_LINK_TEXT_SHORT: "Product disclosure",
    INITIAL_INFORMATION_LINK: "Initial disclosure (§ 15 VersVermV)",
    INSURANCES: "Insurers",
    INSURANCE_POLICY: "Product",
    INSURANCE_POLICY_TEXT:
      "The insurer will send your insurance documents to you (the policyholder) by post or email.",
    INVITATIO_BOOKING_COMPLETED_INFO_1: `Your request has been received. You will shortly receive a confirmation email at <strong>{email}</strong>.
      If you do not see it, please check your spam folder.`,
    INVITATIO_BOOKING_COMPLETED_INFO_2:
      "Please note that cover does not take effect until <strong>{name}</strong> has accepted your request and the initial premium has been paid.",
    INVITATIO_BOOKING_COMPLETED_INFO_4:
      "Your request is stored in our system under the reference below. Please cite this reference whenever you contact us.",
    INVITATIO_BOOKING_COMPLETED_INFO_5:
      "Below you will find the documents you need for your request and other helpful links. Please note that your insurance documents will be issued directly by the insurer.",
    INVITATIO_BOOKING_COMPLETED_INFO_5_NO_SERVICE_APP:
      "Below you will find the documents you need for your request. Please note that your insurance documents will be issued directly by the insurer.",
    INVITATIO_BOOKING_COULD_NOT_COMPLETE_RETRY:
      "The quote request could not be completed. Please try again.",
    INVITATIO_BOOKING_SESSION_ALREADY_CONFIRMED:
      "Your quote request has already been received. You do not need to submit it again.",
    INVITATIO_BOOKING_SESSION_ALREADY_CONFIRMED_WITH_ID:
      "Your quote request has already been received. You do not need to submit it again. Request ID: A-{bookingId}",
    INVITATIO_BOOKING_FOOTER_PRICE_ON_REQUEST: "On request",
    INVITATIO_BOOKING_NETWORK_UNCERTAINTY_TOAST:
      "The connection was interrupted. If your quote request was successful, you will find the confirmation on the next page. Please verify.",
    INVITATIO_BOOK_ANOTHER_CONTRACT: "Submit another request",
    INVITATIO_BOOK_LAST_PAGE: "Submit quote request",
    INVITATIO_CHECKING_CONTRACT:
      "We are reviewing your request and forwarding it to the selected insurer.",
    INVITATIO_CONTRACT_DONE: "We have received your request",
    INVITATIO_CONTRACT_DONE_TARIFF_INFO_TITLE: "Your desired cover",
    INVITATIO_CONTRACT_PROCESSING: "Policy issuance",
    INVITATIO_CONTRACT_PROCESSING_TEXT:
      "The insurer is processing your request.",
    INVITATIO_CONTRACT_SUBMISSION: "Request review",
    INVITATIO_INSURANCE_POLICY: "Insurance policy",
    INVITATIO_INSURANCE_POLICY_TEXT:
      "After reviewing your request, the insurer will inform you of the next steps and, where applicable, send your contract documents by post or email.",
    INVITATIO_PLEASE_WAIT_CONTRACT_NUM:
      "Please wait until your reference has been generated.",
    INVITATIO_TARIFF_BLOCK_BOOK: "Request a quote",
    INVITATIO_VERIFICATION_ALREADY_VERIFIED_P1:
      "Your email address has already been confirmed. Your request with reference <strong>{bookingId}</strong> has been received successfully.",
    INVITATIO_VERIFICATION_BOOKING_PENDING_BODY:
      "To instruct us to forward your request with reference <strong>{bookingData}</strong> to <strong>{insurerName}</strong>, please click the <strong>“Confirm email address”</strong> link in the email we have just sent to <strong>{email}</strong>. If you do not receive an email, please check your spam folder.",
    INVITATIO_VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "We will only forward your request once you have completed the email confirmation successfully.",
    INVITATIO_VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "The link to confirm your request with reference <strong>{bookingId}</strong> is no longer valid. We will not process your request any further.",
    INVITATIO_VERIFICATION_SUCCESS_COVER_NOTICE:
      "<strong>Please note:</strong> Cover only exists once <strong>{insurerName}</strong> has accepted and confirmed your request. Only the cover set out in the terms and conditions applies. The benefit features we display are updated to the best of our knowledge. For your insurance contract, however, solely the scope of cover stated in the terms and conditions applies.",
    INVITATIO_VERIFICATION_SUCCESS_RECEIVED_BODY:
      "Your request with reference <strong>{bookingId}</strong> has been received successfully. You will shortly receive a confirmation email at <strong>{policyHolderEmail}</strong>. If you do not receive an email, please check your spam folder.",
    INVITATIO_VERIFICATION_SUCCESS_TITLE: "Your request is now being processed",
    INVITATIO_VERIFICATION_POLICY_START_CHANGED_BODY:
      "The originally selected policy start date is no longer available for this tariff. Your request can only continue with a new policy start date and the adjusted premium.",
    INVITATIO_VERIFICATION_POLICY_START_CHANGED_NOTE:
      "Your request will only be processed further after you confirm.",
    INVITATIO_VERIFICATION_POLICY_START_BOOKING_LABEL: "Request reference: ",
    INVITATIO_SEPA_VERIFICATION_BOOKING_PENDING_BODY:
      "Please confirm that we may collect premiums from your account by SEPA direct debit. In the email we sent to <strong>{email}</strong>, use the confirmation link (e.g. <strong>“SEPA confirmation”</strong>) for your request with reference <strong>{bookingData}</strong> to <strong>{insurerName}</strong>. If you do not receive an email, please check your spam folder.",
    INVITATIO_SEPA_VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "Without timely confirmation of the SEPA mandate, we cannot collect premiums by direct debit. We will only process your request after the confirmation is completed successfully.",
    INVITATIO_SEPA_VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "The link to confirm your SEPA direct debit authorisation for your request with reference <strong>{bookingId}</strong> is no longer valid. We will not process that request any further in this context.",
    INVITATIO_SEPA_VERIFICATION_ALREADY_VERIFIED_P1:
      "Your SEPA direct debit authorisation is already confirmed. Your request with reference <strong>{bookingId}</strong> has been received successfully.",
    INVITATIO_SEPA_VERIFICATION_SUCCESS_MESSAGE:
      '<p>Your SEPA direct debit mandate for your request with reference <strong>{bookingId}</strong> has been stored for you.</p><p>Thank you for agreeing to premium collection by direct debit.</p><p>Your contract becomes legally effective as of the first premium payment.</p><p class="mb-0">With kind regards<br />Your service team</p>',
    SAVE_SESSION_PARTICIPANT_STATUS_PENDING: "Pending",
    SAVE_SESSION_PARTICIPANT_STATUS_INVITED: "Invited",
    SAVE_SESSION_PARTICIPANT_STATUS_ACCEPTED: "Accepted",
    SAVE_SESSION_PARTICIPANT_STATUS_OPENED: "Opened",
    SAVE_SESSION_PARTICIPANT_LAST_OPENED: "Last opened: {date}",
    SAVE_SESSION_PARTICIPANT_STATUS_OWNER: "owner",
    SAVE_SESSION_PARTICIPANT_ACCEPTED_AT: "Accepted: {date}",
    SEPA_VERIFICATION_SUCCESS_MESSAGE:
      '<p>Your SEPA direct debit mandate for your application with reference <strong>{bookingId}</strong> has been stored for you.</p><p>Thank you for agreeing to premium collection by direct debit.</p><p>Your contract(s) will become legally effective as of the first premium payment.</p><p class="mb-0">With kind regards<br />Your service team</p>',
    SEPA_VERIFICATION_ALREADY_VERIFIED_P1:
      "Your SEPA direct debit authorisation is already confirmed. Your insurance application with reference <strong>{bookingId}</strong> has been received successfully.",
    SEPA_VERIFICATION_ALREADY_VERIFIED_TITLE:
      "Your SEPA direct debit is already confirmed",
    SEPA_VERIFICATION_BOOKING_PENDING_BODY:
      "Please confirm that we may collect premiums from your account by SEPA direct debit. In the email we sent to <strong>{email}</strong>, use the confirmation link (e.g. <strong>“SEPA confirmation”</strong>) for your application with reference <strong>{bookingData}</strong> to <strong>{insurerName}</strong>. If you do not receive an email, please check your spam folder.",
    SEPA_VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "Without timely confirmation of the SEPA mandate, we cannot collect premiums by direct debit. We will only process your application to take out insurance after the confirmation is completed successfully.",
    SEPA_VERIFICATION_BOOKING_PENDING_TITLE:
      "Please confirm your SEPA direct debit authorisation",
    SEPA_VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "The link to confirm your SEPA direct debit for your application with reference <strong>{bookingId}</strong> is no longer valid. We will not process your application to take out insurance any further in this context.",
    SEPA_VERIFICATION_LINK_EXPIRY_NOTICE:
      "<strong>Please note that the confirmation link for your SEPA direct debit is only valid until {date} at 23:59.</strong>",
    SEPA_VERIFICATION_SUCCESS_TITLE: "Confirmation successful!",
    INVITATIO_WHAT_IS_NEXT: "What happens next",
    INVITATIO_WHAT_IS_NEXT_SUBMIT_TITLE: "Submit request",
    INVITATIO_WHAT_IS_NEXT_SUBMIT_TEXT: "We have received your request.",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_EMAIL_VALIDATION_TEXT:
      "Please confirm your email using the link in our message.",
    INVITATIO_WHAT_IS_NEXT_EMAIL_VALIDATION_TITLE: "Confirm email",
    INVITATIO_WHAT_IS_NEXT_EMAIL_VALIDATION_TEXT:
      "Please confirm your email address using the link in the email we sent to <strong>{email}</strong>. Only then can we forward your request.",
    INVITATIO_WHAT_IS_NEXT_REQUEST_REVIEW_TITLE: "Review request",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_REQUEST_REVIEW_TEXT:
      "We review your request for completeness.",
    INVITATIO_WHAT_IS_NEXT_REQUEST_REVIEW_TEXT:
      "We review your request for completeness and plausibility.",
    INVITATIO_WHAT_IS_NEXT_TRANSMISSION_TITLE: "Submission",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_TRANSMISSION_TEXT:
      "We forward your request to the insurer.",
    INVITATIO_WHAT_IS_NEXT_TRANSMISSION_TEXT:
      "We forward your request to the selected insurance company.",
    INVITATIO_WHAT_IS_NEXT_POLICY_ISSUANCE_TITLE: "Policy issuance",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_POLICY_ISSUANCE_TEXT:
      "The insurer processes your request.",
    INVITATIO_WHAT_IS_NEXT_PROGRESS_INSURANCE_POLICY_TEXT:
      "The insurer sends you the policy documents.",
    INVITATIO_YOUR_CONTRACT_NUM: "Your request",
    IS_REQUIRED_FIELD: "This field is required",
    IS_WRONG_FORMAT: "is invalid",
    I_HAVE_CONTRACT_TEXT_PART_4_COVOMO:
      "I acknowledge and agree to the terms presented by {brandName} as intermediary.",
    LEGAL_MATTERS: "Legal",
    LINKOUT_APPLICANT_HEADING: "Applicant",
    LINKOUT_DATE_PLACEHOLDER: "DD.MM.YYYY",
    LINKOUT_INTRO_COMPARISON:
      "You are now leaving the comparison calculator and will be redirected to the online application journey of the product provider {insurer}.",
    LINKOUT_INTRO_POLICYHOLDER:
      "So that we can track and support your application afterwards, please complete the following details for the policyholder.",
    LINKOUT_INTRO_POLICYHOLDER_NO_SERVICE_APP:
      "Please complete the following details for the policyholder.",
    LINKOUT_OVERLAY_APPLICANT_DETAILS: "Applicant details",
    LINKOUT_OVERLAY_CLOSE_WINDOW: "Close window",
    LINKOUT_OVERLAY_REDIRECTING: "You are being redirected…",
    LINKOUT_PRIVACY_CONSENT:
      "If you continue, you declare that you have read the {privacyLink} of the product provider and agree to the processing of your data by {insurer}.",
    LINKOUT_PRIVACY_LINK_TEXT: "privacy policy",
    LINKOUT_QUOTE_COMPLETED: "Your quote request has been completed.",
    LINKOUT_QUOTE_INTRO_LINE: "Quote for international health insurance",
    LINKOUT_REDIRECT_CLICK_HERE: "click here",
    LINKOUT_REDIRECT_COUNTDOWN: "You will be redirected in {count} seconds.",
    LINKOUT_REDIRECT_FALLBACK:
      "If the redirection does not work automatically, {link}.",
    LINK_HERE: "here",
    MAIN_SERVICES: "Key benefits",
    MARKETING_AFFILIATE_CHECKBOX: `Under Art. 15 GDPR you may request information from {0} about personal data stored about you.
      Under Art. 17 GDPR you may also request correction, erasure, or restriction of processing of personal data. You may object at any time without giving reasons and change or withdraw your consent for the future. You will only incur transmission costs at basic rates. Send objections to: {1} or the address above.
      Full privacy information for {2} is available `,
    MARKETING_CHECKBOX:
      "I also agree that {brandName}’s partner {0}, {1}, {2}, may email me information and offers about insurance products for marketing purposes.",
    MOBILE_FILTERS_MORE: "More filters",
    MOBILE_OVERLAY_FIND_TARIFFS: "Find products",
    MOBILE_OVERLAY_SHOW_RESULTS: "Show {count} result | Show {count} results",
    MOBILE_UPLOAD_TITLE: "Upload document",
    MOBILE_UPLOAD_LOADING: "The upload link is being loaded …",
    MOBILE_UPLOAD_REFERENCE: "Application reference",
    MOBILE_UPLOAD_REQUIRED_DOCUMENT: "Required document",
    MOBILE_UPLOAD_SELECT_FILE: "Choose file",
    MOBILE_UPLOAD_FILE_HINT: "JPG, PNG or PDF · maximum {maxSizeMb} MB",
    MOBILE_UPLOAD_CONFIRM: "Upload & confirm",
    MOBILE_UPLOAD_UPLOADING: "Uploading document …",
    MOBILE_UPLOAD_INTRO:
      "Your application was recognized. Please upload the following document:",
    MOBILE_UPLOAD_SUCCESS:
      "Document transferred successfully. You can close this window.",
    MOBILE_UPLOAD_INVALID: "This upload link is invalid.",
    MOBILE_UPLOAD_EXPIRED:
      "This upload link has expired or has already been used. Please open a new QR code on the computer.",
    MOBILE_UPLOAD_LOAD_ERROR:
      "The upload link could not be loaded. Please try again.",
    MOBILE_UPLOAD_TYPE_ERROR: "Please select a JPG, PNG or PDF file.",
    MOBILE_UPLOAD_SIZE_ERROR:
      "The selected file is too large. The maximum file size is {maxSizeMb} MB.",
    MOBILE_UPLOAD_INFECTED_ERROR:
      "The file could not be accepted for security reasons. Please select another file.",
    MOBILE_UPLOAD_FILE_REQUIRED_ERROR: "Please select a file.",
    MOBILE_UPLOAD_SERVER_ERROR:
      "The document could not be transferred. Please try again.",
    MOBILE_UPLOAD_RETRY: "Try again",
    MOBILE_UPLOAD_SELECT_ANOTHER: "Choose another file",
    MULTISELECT_SELECTED: "{count} selected",
    NOT_INCLUDED: "Not included",
    NO_CONSULTANCY_POPUP_TEXT_COVOMO_APPLICANT:
      "<p>I completed this application myself and chose the product based on a specific need. An advisory record will be prepared for the product choice and online advisory session. I expressly waive in-person advice and advice on other insurance products.</p>",
    NO_CONSULTANCY_POPUP_TEXT_COVOMO_BROKER:
      "<p>I completed this application on the customer’s behalf and chose the product based on a specific need. An advisory record will be prepared for the product choice and online advisory session. The customer expressly waives in-person advice and advice on other insurance products. I confirm I am authorised to make this statement on the customer’s behalf.</p>",
    NO_FILE_DETECTED: "No file selected",
    NO_OPTIONS_IN_SELECT: "No options available",
    NO_TARIFFS: "No products match your current search.",
    ERSTINFORMATION_CONSENT_REQUIRED_BEFORE_SEARCH:
      "Please confirm the initial information to start the product search.",
    NO_TARIFFS_FOR_SELECTED_FILTERS:
      "No products match your current search and filters.",
    NO_TARIFFS_FOUND: "No products found",
    NO_VALUE_FOUND: "No results found",
    OPTIONAL: "Optional",
    PAGE_NOT_FOUND: "Page not found",
    PAGE_HEADING_ACCESSIBILITY: "Accessibility statement",
    PAGE_HEADING_ASSESSMENT: "Risk assessment",
    PAGE_HEADING_BOOKING: "Application",
    PAGE_HEADING_BOOKING_COMPLETE: "Application complete",
    PAGE_HEADING_BOOKING_REVIEW: "Review application",
    PAGE_HEADING_BOOKING_STEP2: "Application – payment",
    PAGE_HEADING_COMPARISON: "Product comparison",
    PAGE_HEADING_CONTRACT_RENEWAL: "Renew contract",
    PAGE_HEADING_DEFAULT: "Comparison calculator",
    PAGE_HEADING_NOT_FOUND: "Page not found",
    PAGE_HEADING_RESUME_BOOKING: "Resume application",
    PAGE_HEADING_SEARCH: "Tariff search",
    PAGE_HEADING_TARIFF: "Tariff details",
    PAGE_HEADING_VERIFICATION: "Email verification",
    PAGE_HEADING_WIZARD: "Needs check",
    PAGE_HEADING_STEP_BY_STEP: "Step by step",
    PAGE_TITLE_ACCESSIBILITY: "Accessibility statement {'|'} {siteName}",
    PAGE_TITLE_ASSESSMENT: "Risk assessment {'|'} {siteName}",
    PAGE_TITLE_BOOKING: "Application {'|'} {siteName}",
    PAGE_TITLE_BOOKING_COMPLETE: "Application complete {'|'} {siteName}",
    PAGE_TITLE_BOOKING_REVIEW: "Review application {'|'} {siteName}",
    PAGE_TITLE_BOOKING_STEP2: "Application – payment {'|'} {siteName}",
    PAGE_TITLE_COMPARISON: "Product comparison {'|'} {siteName}",
    PAGE_TITLE_CONTRACT_RENEWAL: "Renew contract {'|'} {siteName}",
    PAGE_TITLE_DEFAULT: "{siteName} comparison calculator",
    PAGE_TITLE_MOBILE_UPLOAD: "Upload document {'|'} {siteName}",
    PAGE_DESCRIPTION_MOBILE_UPLOAD:
      "Securely upload a document from your smartphone.",
    PAGE_TITLE_NOT_FOUND: "Page not found {'|'} {siteName}",
    PAGE_TITLE_RESUME_BOOKING: "Resume application {'|'} {siteName}",
    PAGE_TITLE_SEARCH: "Tariff search {'|'} {siteName}",
    PAGE_TITLE_TARIFF: "Tariff details {'|'} {siteName}",
    PAGE_TITLE_VERIFICATION: "Email verification {'|'} {siteName}",
    PAGE_TITLE_WIZARD: "Needs check {'|'} {siteName}",
    PAGE_TITLE_STEP_BY_STEP: "Step by step {'|'} {siteName}",
    PAGE_DESCRIPTION_DEFAULT:
      "Compare insurance tariffs and apply online – {brandName}.",
    PAGE_DESCRIPTION_SEARCH:
      "Compare tariffs, review benefits, and apply online – {brandName}.",
    PAGE_DESCRIPTION_WIZARD:
      "Find suitable insurance coverage with the needs check – {brandName}.",
    PAGE_DESCRIPTION_COMPARISON:
      "Compare selected tariffs and benefits in detail – {brandName}.",
    PAGE_DESCRIPTION_TARIFF:
      "Tariff details, benefits, and prices at a glance – {brandName}.",
    PAGE_DESCRIPTION_ASSESSMENT:
      "Risk assessment for your insurance application – {brandName}.",
    PAGE_DESCRIPTION_BOOKING:
      "Complete and submit your insurance application online – {brandName}.",
    PAGE_DESCRIPTION_BOOKING_STEP2:
      "Enter payment details for your insurance application – {brandName}.",
    PAGE_DESCRIPTION_BOOKING_REVIEW:
      "Review and submit your application – {brandName}.",
    PAGE_DESCRIPTION_BOOKING_COMPLETE:
      "Your insurance application was submitted successfully – {brandName}.",
    PAGE_DESCRIPTION_VERIFICATION:
      "Verify your email address for your insurance application – {brandName}.",
    PAGE_DESCRIPTION_RESUME_BOOKING:
      "Resume an interrupted insurance application – {brandName}.",
    PAGE_DESCRIPTION_NOT_FOUND:
      "The requested page could not be found – {brandName}.",
    PAGE_DESCRIPTION_ACCESSIBILITY:
      "Accessibility statement for this comparison calculator – {brandName}.",
    SKIP_TO_CONTENT: "Skip to main content",
    HEADER_NAV_LABEL: "Main navigation",
    FOOTER_ACCESSIBILITY_LINK: "Accessibility",
    A11Y_COMPARE_ADDED: "{name} added to comparison.",
    A11Y_TARIFF_CARD_FOOTER_ACTIONS: "Actions for tariff {name}",
    A11Y_COMPARE_REMOVED: "{name} removed from comparison.",
    A11Y_SEARCH_RESULTS_COUNT: "{count} tariff found. | {count} tariffs found.",
    A11Y_SEARCH_RESULTS_NONE: "No tariffs found.",
    BOOKING_ERROR_SUMMARY_TITLE: "Please correct the following:",
    PAGE_NOT_FOUND_BUTTON: "Return to comparison",
    PAGE_NOT_FOUND_TEXT:
      "We couldn’t find that page, or the link you used is no longer valid.",
    PARTIALLY_INCLUDED: "Included (see notice)",
    PAYER_FORM_TITLE: "Premium payer",
    FILTER_CLEAR_SELECTION: "Clear selection",
    PAYMENT_INTERVAL_CLEAR_SELECTION: "Clear selection",
    PAYMENT_INTERVAL_REQUIRED: "Please select a payment frequency.",
    PAYMENT_INTERVAL_TITLE: "Payment frequency",
    PAYMENT_INTERVAL_MONTHLY: "per month",
    PAYMENT_INTERVAL_QUARTERLY: "per quarter",
    PAYMENT_INTERVAL_SEMIANNUAL: "per half-year",
    PAYMENT_INTERVAL_ANNUAL: "per year",
    PAYMENT_INTERVAL_ONCE: "One-time payment",
    PAYMENT_INTERVAL_WEEKLY: "per week",
    PAYMENT_INTERVAL_DAILY: "per day",
    PAYMENT_INTERVAL_ANNUAL_TOTAL: "{price} / year",
    PAYMENT_INTERVAL_SAVINGS: "You save {price} / year",
    PAYMENT_INTERVAL_UNAVAILABLE: "Not available",
    PAYMENT_INTERVAL_UNAVAILABLE_TOOLTIP:
      "This payment frequency is not offered for the calculated premium — often because the premium is below the insurer’s minimum for this frequency. Please choose one of the available options.",
    PAYMENT_INTERVAL_CHEAPEST_TOOLTIP:
      "Lowest price for the currently selected product — among the available payment frequencies shown here for this product.",
    PAYMENT_METHOD: "Payment method",
    PAYMENT_SECTION: "Payment",
    PLEASE_FILL_FIELD: "Please complete this field.",
    PLEASE_WAIT_CONTRACT_NUM:
      "Please wait while your application number is generated.",
    PREMIUM_CALC_ERROR_BODY_P1:
      "Based on the information you provided, the expected insurance premium cannot be calculated.",
    PREMIUM_CALC_ERROR_BODY_P2_PREFIX:
      "Please try again. If the error persists, please contact our customer service at ",
    PREMIUM_CALC_ERROR_BUTTON: "Back to results",
    PREMIUM_CALC_ERROR_TITLE: "Premium calculation error",
    PRICE: "Premium",
    PRICE_ASC: "€",
    PRICE_ASC_MOBILE: "Lowest premium",
    PRICE_DESC: "€€€",
    PRICE_DESC_MOBILE: "Highest premium",
    PRICE_UPDATE_MODAL_ALERT_VARIANTS: {
      priceOnly: "The insurance premium has changed.",
      contractOnlyToInquiry: "This product now requires an inquiry.",
      contractOnlyFromInquiry:
        "This product no longer requires an inquiry and can now be applied for directly.",
      priceAndContractToInquiry:
        "The insurance premium has changed and this product now requires an inquiry.",
      priceAndContractFromInquiry:
        "The insurance premium has changed and this product can now now be applied for directly.",
    },
    PRICE_UPDATE_MODAL_ALERT_UNAVAILABLE:
      "This product cannot be completed with your current details.",
    PRICE_UPDATE_MODAL_CONFIRM_BUTTON: "Confirm new premium",
    PRICE_UPDATE_MODAL_CONFIRM_BUTTON_CONTRACT: "Confirm changes",
    PRICE_UPDATE_MODAL_IMPORTANT_LABEL: "Important notice:",
    PRICE_UPDATE_MODAL_NEW_PREMIUM: "New premium",
    PRICE_UPDATE_MODAL_OLD_PREMIUM: "Previous premium",
    PRICE_UPDATE_MODAL_RECALC_CONFIRM:
      "Please confirm the new premium to continue.",
    PRICE_UPDATE_MODAL_RECALC_PREFIX:
      "Based on your entries, the insurance premium has been recalculated and is now ",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_TO_INQUIRY:
      "Based on your latest entries, this product now requires an inquiry.",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_TO_INQUIRY:
      "Please confirm the changes to continue.",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_FROM_INQUIRY:
      "Based on your latest entries, this product no longer requires an inquiry and can now be applied for directly.",
    PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_FROM_INQUIRY:
      "Please confirm the changes to continue with the application.",
    PRICE_UPDATE_MODAL_SENTENCE_DOT: ".",
    PRICE_UPDATE_MODAL_BODY_VARIANTS: {
      empty: [],
      priceOnly: [
        "@:message.PRICE_UPDATE_MODAL_RECALC_PREFIX",
        "__PRICE__",
        "@:message.PRICE_UPDATE_MODAL_SENTENCE_DOT",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_RECALC_CONFIRM",
      ],
      contractOnlyToInquiry: [
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_TO_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_TO_INQUIRY",
      ],
      contractOnlyFromInquiry: [
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_FROM_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CONFIRM_FROM_INQUIRY",
      ],
      priceAndContractToInquiry: [
        "@:message.PRICE_UPDATE_MODAL_RECALC_PREFIX",
        "__PRICE__",
        "@:message.PRICE_UPDATE_MODAL_SENTENCE_DOT",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_TO_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_RECALC_CONFIRM",
      ],
      priceAndContractFromInquiry: [
        "@:message.PRICE_UPDATE_MODAL_RECALC_PREFIX",
        "__PRICE__",
        "@:message.PRICE_UPDATE_MODAL_SENTENCE_DOT",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_CONTRACT_MODEL_CHANGED_FROM_INQUIRY",
        "__BREAK__",
        "@:message.PRICE_UPDATE_MODAL_RECALC_CONFIRM",
      ],
    },
    PRICE_UPDATE_MODAL_TITLE_CHANGED: "The premium has changed",
    PRICE_UPDATE_MODAL_TITLE_CONTRACT_CHANGED:
      "The application status has changed",
    PRICE_UPDATE_MODAL_TITLE_UNAVAILABLE: "This product is no longer available",
    PRICE_UPDATE_MODAL_UNAVAILABLE_BODY:
      "Based on your latest entries, this product no longer meets the insurer’s underwriting guidelines. It cannot be purchased at this time.",
    PRINT: "Print",
    PRINT_RESULTS: "Print",
    PRINT_THIS_SITE: "Print this page",
    PRODUCT_PROVIDER: "Product provider",
    REACH_US_TEXT: "Contact us Mon–Fri, 9am–5pm",
    REQUEST_OTP_LOCKED_ERROR_BODY:
      "Too many failed attempts. Please wait {seconds} seconds before requesting a new one-time code.",
    REQUEST_OTP_RATE_LIMITED_ERROR_BODY:
      "You have already requested a one-time code. Please wait {seconds} seconds before requesting a new one-time code.",
    REQUEST_CODE: "Request one-time code",
    RESET_FILTERS: "Reset filters",
    RESUME_BOOKING_LOADER_ERROR_SESSION_NOT_FOUND:
      "The saved application draft could not be found or has been deleted.",
    RESUME_BOOKING_LOADER_ERROR_SESSION_COMPLETED:
      "This booking has already been completed. The invitation link is therefore no longer valid.",
    RESUME_BOOKING_LOADER_ERROR_SESSION_EXPIRED:
      "This saved application draft has expired.",
    RESUME_BOOKING_LOADER_TITLE: "Your application draft is being prepared",
    RESUME_BOOKING_LOADER_SUBTITLE:
      "Please wait while we load your saved application draft.",
    RESUME_BOOKING_LOADER_STEP_SESSION: "Loading data",
    RESUME_BOOKING_LOADER_STEP_SEARCH_FORM: "Loading search form",
    RESUME_BOOKING_LOADER_STEP_TARIFFS: "Searching tariffs",
    RESUME_BOOKING_LOADER_STEP_BOOKING_FORM: "Preparing booking form",
    RESUME_BOOKING_LOADER_ERROR_TITLE: "This step could not be completed",
    RESUME_BOOKING_LOADER_ERROR_SESSION:
      "The saved application draft could not be loaded.",
    RESUME_BOOKING_LOADER_ERROR_SEARCH_FORM:
      "The search form could not be loaded. Please try again later.",
    RESUME_BOOKING_LOADER_ERROR_TARIFFS:
      "The selected tariff is no longer available. Alternatively, you can start a new tariff search.",
    RESUME_BOOKING_LOADER_ERROR_BOOKING_FORM:
      "The booking form could not be loaded. Please try again later.",
    RESUME_BOOKING_LOADER_ERROR_GENERIC:
      "Something went wrong while resuming your booking. Please try again later.",
    RESUME_BOOKING_LOADER_SEARCH_NEW_TARIFF_HINT:
      "Alternatively, you can start a new tariff search.",
    RESUME_BOOKING_LOADER_SEARCH_NEW_TARIFF_LINK: "Search for a new tariff",
    RESUME_BOOKING_CONFIRM_KICKER: "Your application draft",
    RESUME_BOOKING_CONFIRM_TITLE_PREFIXED: "Application draft: {title}",
    RESUME_BOOKING_AUTH_ILLUSTRATION_TEXT:
      "To protect your application draft, we will send you a confirmation code by email.",
    RESUME_BOOKING_CONFIRM_REDIRECT_DESCRIPTION_GENERIC:
      "The verification code will be sent by email. Please wait. You will be redirected to code entry shortly.",
    RESUME_BOOKING_CONFIRM_DESCRIPTION:
      "Enter the email address linked to this application draft. We will send a one-time code to that address for access to the application draft.",
    RESUME_BOOKING_CONFIRM_EMAIL_LOADING_DESCRIPTION:
      "We are checking which email address the verification code should be sent to …",
    RESUME_BOOKING_CONFIRM_CODE_PLACEHOLDER: "Access code",
    RESUME_BOOKING_CONFIRM_REDIRECT_DESCRIPTION:
      "The verification code will be sent to {email}.",
    RESUME_BOOKING_CONFIRM_EMAIL_HINT: "One-time code will be sent to {email}",
    RESUME_BOOKING_VERIFY_TITLE: "Enter one-time code",
    RESUME_BOOKING_VERIFY_DESCRIPTION:
      "The one-time code was sent to {email}. Please check your inbox and enter the 9-digit one-time code below.",
    RESUME_BOOKING_VERIFY_DESCRIPTION_PENDING:
      "Request a one-time code first. You can then enter the 9-digit one-time code here.",
    RESUME_BOOKING_VERIFY_CODE_ARIA_LABEL: "9-digit confirmation code",
    RESUME_BOOKING_VERIFY_BUTTON: "Confirm one-time code",
    RESUME_BOOKING_VERIFY_CODE_EXPIRY:
      "The one-time code is valid for another {time}.",
    RESUME_BOOKING_VERIFY_RESEND_COUNTDOWN: "Resend in {time}",
    RESUME_BOOKING_VERIFY_RESEND_QUESTION: "Didn’t receive the one-time code?",
    RESUME_BOOKING_VERIFY_ERROR_TITLE: "Verification failed",
    RESUME_BOOKING_VERIFY_ERROR_BODY:
      "Please check the one-time code you entered or request a new one-time code.",
    RESUME_BOOKING_VERIFY_RESEND_BUTTON: "Send a new one-time code.",
    VERIFY_OTP_BLANK_ERROR_BODY: "Please enter the verification code.",
    VERIFY_OTP_INVALID_ERROR_BODY:
      "The one-time code you entered is invalid. Please check the one-time code in your email and try again.",
    VERIFY_OTP_INVALID_LOCKED_ERROR_BODY:
      "Too many attempts. Please try again in {time}.",
    VERIFY_OTP_LOCKED_ERROR_BODY:
      "Too many attempts. Please try again in {time}.",
    VERIFY_OTP_ALREADY_CONSUMED_ERROR_BODY:
      "This one-time code has already been used. Please request a new one-time code.",
    VERIFY_OTP_NO_ACTIVE_OTP_ERROR_BODY:
      "No active one-time code was found. Please request a new one-time code.",
    VERIFY_OTP_RATE_LIMITED_ERROR_BODY:
      "Please wait {seconds} seconds before requesting a new one-time code.",
    VERIFY_OTP_EXPIRED_ERROR_BODY:
      "The one-time code you entered has expired. Please request a new one-time code and try again.",
    RISK_CARRIER: "Underwriting insurer",
    RISK_ZONE_COULD_NOT_BE_DETERMINED: "The ZÜRS zone could not be determined.",
    SAVE: "Save",
    FEATURE_HIGHLIGHT_SAVE_BUTTON_TITLE: "Save draft",
    FEATURE_HIGHLIGHT_SAVE_BUTTON_BODY:
      "Save your application as a draft. All you need is an email address so we can send you a personal link to your application.",
    FEATURE_HIGHLIGHT_DISMISS: "Got it",
    FEATURE_HIGHLIGHT_NEXT: "Next",
    FEATURE_HIGHLIGHT_STEP_OF: "Tip {current} of {total}",
    FEATURE_HIGHLIGHT_SEARCH_INSURER_ROW_TITLE: "Quick compare",
    FEATURE_HIGHLIGHT_SEARCH_INSURER_ROW_BODY:
      "Here you can find the products of all insurers with their cheapest price. Click on the insurer to show the products of this insurer.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_TITLE: "Tariff actions",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY:
      "Here you’ll find the available tariff actions: select the tariff for an offer, optionally add a comment, select multiple tariffs for comparison, or print all details for the tariff.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_MARK_COMPARE:
      "Here you’ll find the available tariff actions: select the tariff for an offer, optionally add a comment, and select multiple tariffs for comparison.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_MARK_PRINT:
      "Here you’ll find the available tariff actions: select the tariff for an offer, optionally add a comment, or print all details for the tariff.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_MARK:
      "Here you’ll find the available tariff actions: select the tariff for an offer and optionally add a comment.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_COMPARE_PRINT:
      "Here you’ll find the available tariff actions: select multiple tariffs for comparison or print all details for the tariff.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_COMPARE:
      "Here you’ll find the available tariff actions: select multiple tariffs for comparison.",
    FEATURE_HIGHLIGHT_SEARCH_TOOLBAR_BODY_PRINT:
      "Here you’ll find the available tariff actions: print all details for the tariff.",
    FEATURE_HIGHLIGHT_SEARCH_PAYMENT_FOOTER_TITLE: "Payment options below",
    FEATURE_HIGHLIGHT_SEARCH_PAYMENT_FOOTER_BODY:
      'Payment options are now at the bottom of the tariff card. Click "Payment options" to see all intervals with annual premium and the cheapest price per payment method.',
    FEATURE_HIGHLIGHT_SEARCH_VIEW_MENU_TITLE: "Adjust display",
    FEATURE_HIGHLIGHT_SEARCH_VIEW_MENU_BODY:
      "Change theme, contrast, and font size using the Display menu.",
    FEATURE_HIGHLIGHT_DOCUMENTS_ZIP_TITLE: "All documents at once",
    FEATURE_HIGHLIGHT_DOCUMENTS_ZIP_BODY:
      "Download all documents for your application as a single ZIP file.",
    FEATURE_HIGHLIGHT_MOBILE_UPLOAD_TITLE: "New: upload from your phone",
    FEATURE_HIGHLIGHT_MOBILE_UPLOAD_BODY:
      "Scan the QR code to upload documents from your smartphone – no extra sign-in required.",
    SAVE_AND_SEND: "Save and send",
    SAVE_NOW: "Save now",
    SAVED_SESSION: "Saved. Resume link: {resumeUrl}",
    SAVE_SESSION_COMPLETED_COPIED: "Link copied",
    SAVE_SESSION_COMPLETED_COPY_LINK: "Copy link",
    SAVE_SESSION_COMPLETED_EMAIL_SENT: "Confirmation sent to {email}",
    SAVE_SESSION_COMPLETED_LINK_LABEL: "Link to application draft",
    SAVE_SESSION_COMPLETED_TITLE: "Successfully saved",
    SAVE_SESSION_DEFAULT_TITLE: "My {appName} insurance",
    SAVE_SESSION_EMAILS: "Email addresses",
    SAVE_SESSION_EMAIL_PLACEHOLDER: "Enter another email…",
    SAVE_SESSION_INACTIVITY_DISCLAIMER:
      "Saved application drafts are automatically deleted after 30 days of inactivity.",
    SAVE_SESSION_INSURER_FALLBACK: "the insurer",
    SAVE_SESSION_NOT_TRANSMITTED:
      "The application has not yet been submitted to the responsible insurer.",
    SAVE_SESSION_DRAFT_DISCLAIMER:
      "<strong>Please note:</strong> This is a saved draft of an insurance application. A legally binding application is only created when you submit it via the “{submitButton}” button. Saving does not create a contractual relationship. Cover only exists once <strong>{insurerName}</strong> has expressly accepted your application.",
    SAVE_SESSION_SHARE_WITH_BROKER_HELPER:
      "The aforementioned broker gets access to this application draft you have saved. You can deactivate this option at any time.",
    SAVE_SESSION_SHARE_WITH_BROKER:
      "Allow {brokerName} access to my saved application draft",
    SAVE_SESSION_NOTE: "Note",
    SAVE_SESSION_NOTE_ADD: "Advanced settings",
    SAVE_SESSION_NOTIFY_PARTICIPANTS_LABEL:
      "Notify other participants about changes",
    SAVE_SESSION_NOTIFY_PARTICIPANTS_QUESTION:
      "Would you like to notify the other participants about your changes?",
    SAVE_SESSION_NOTIFY_SEND: "Send",
    SAVE_SESSION_NOTIFY_NOW: "Notify now",
    SAVE_SESSION_NOTIFY_SENT_LABEL: "Notified",
    SAVE_SESSION_PARTICIPANT_EMAIL_SUCCESS_TITLE: "Email sent",
    SAVE_SESSION_PARTICIPANT_EMAIL_SUCCESS_BODY:
      "The email was sent to everyone and the booking was saved.",
    SAVE_SESSION_PARTICIPANT_EMAIL_ERROR_TITLE: "Email could not be sent",
    SAVE_SESSION_PARTICIPANT_EMAIL_ERROR_BODY:
      "The booking could not be saved or the participants could not be notified. Please try again.",
    SAVE_SESSION_PARTICIPANTS_NOTIFIED_SUCCESS:
      "Participants were notified by email.",
    SAVE_SESSION_PARTICIPANTS_NOTIFIED_ERROR:
      "Changes were saved, but participants could not be notified.",
    SAVE_SESSION_NOTE_PLACEHOLDER: "Personal message for the recipients…",
    SAVE_SESSION_PARTICIPANTS: "Participants",
    SAVE_SESSION_INVITE_PEOPLE: "Invite people",
    SAVE_SESSION_INVITE_BUTTON: "Invite",
    SAVE_SESSION_ADD_ANOTHER_PERSON: "add another person",
    SAVE_SESSION_SEND_INVITATION: "Send invitation",
    SAVE_SESSION_NEW_INTRO:
      "Save your application as a draft. All you need is an email address so we can send you a personal link.",
    SAVE_SESSION_NEW_INTRO_BROKER:
      "Save your application as a draft. Enter a title — the draft will then appear in your drafts overview in the distribution portal.",
    SAVE_SESSION_NEW_INTRO_WITH_SHARING:
      "Save your application as a draft. All you need is an email address so we can send you a personal link. You can then also invite other people to your application.",
    SAVE_SESSION_EDIT_TITLE: "Edit title",
    SAVE_SESSION_EDIT_NOTE: "Edit note",
    SAVE_SESSION_PARTICIPANTS_INTRO:
      "Add other people who should have access to this booking — for example friends, family, your broker, or customers. Each email address can only be used once. This is not the list of insured persons.",
    SAVE_SESSION_PARTICIPANTS_HELPER:
      "All participants receive a link by email and can open the application draft.",
    SAVE_SESSION_PARTICIPANTS_HINT:
      "(email addresses, one per line or separated by commas)",
    SAVE_SESSION_TITLE: "Title",
    SAVE_SESSION_TITLE_REQUIRED: "Please enter a title.",
    SAVE_SESSION_EMAIL_REQUIRED: "Please enter an email address.",
    SAVE_SESSION_MANAGE_DESCRIPTION:
      "To manage participants, permissions, or access links, open application draft management.",
    SAVE_SESSION_MANAGE_TITLE: "Manage draft",
    SAVE_SESSION_SHARE_TITLE: "Share draft",
    SAVE_SESSION_SHARE_MENU_SHARE: "Share draft",
    SAVE_SESSION_SHARE_MENU_EDIT_CALCULATION: "Edit draft",
    SAVE_SESSION_SHARE_MENU_MANAGE_ACCESS: "Manage access",
    SAVE_SESSION_EDIT_CALCULATION_TITLE: "Edit draft",
    SAVE_SESSION_EDIT_CALCULATION_INTRO:
      "Update the title and note for your saved application draft.",
    SAVE_SESSION_MANAGE_ACCESS_TITLE: "Manage access",
    SAVE_SESSION_MANAGE_ACCESS_INTRO:
      "Here you can change names and permissions, and add or remove people. Each email address can only be used once — including the owner’s address, which cannot be invited again. Email addresses cannot be changed after inviting; remove the person and invite them again if needed.",
    SAVE_SESSION_EMAIL_ALREADY_USED: "This email address is already in use.",
    SAVE_SESSION_SAVE_TITLE: "Save draft",
    SAVE_SESSION_TITLE_HELPER: "Automatically suggested — editable",
    SAVE_SESSION_UPDATE_OWNER_LINK: "Owner link to application draft",
    SAVE_SESSION_UPDATE_OWNER_LINK_HELPER:
      "The owner can use this link to open and manage the application draft directly.",
    SAVE_SESSION_UPDATE_GENERAL_LINK: "General link to application draft",
    SAVE_SESSION_UPDATE_GENERAL_LINK_HELPER:
      "Enter an email address saved with this application draft. We will send an email to that address — use the link in that email to open the application draft.",
    SAVE_SESSION_UPDATE_SUCCESS_TITLE: "Application draft saved successfully",
    SAVE_SESSION_UPDATE_SUCCESS_EMAIL_SENT:
      "We sent the link to the application draft to {emails}.",
    SAVE_SESSION_EMAIL_LIST_AND: "and",
    SAVE_SESSION_UPDATE_SUCCESS_SAVED: "The application draft was saved.",
    SAVE_SESSION_UPDATE_SUCCESS_INVITE_HINT:
      "You can invite other people now if you like.",
    SAVE_SESSION_SUCCESS_EMAIL_SENT_LINE:
      "We sent the link to the application draft to {email}.",
    SAVE_SESSION_SUCCESS_PORTAL_DRAFTS_LINE:
      "You can find your draft in the distribution portal under {portalDraftsLink}. We sent the link to your draft to {email}.",
    SAVE_SESSION_SUCCESS_PORTAL_DRAFTS_NAV: "Applications > Drafts",
    SAVE_SESSION_SUCCESS_CHECK_EMAIL:
      "You will receive the link to your application draft within a few minutes. Please check your emails and, if needed, your spam folder.",
    SAVE_SESSION_SUCCESS_SHARE: "Share draft",
    SAVE_SESSION_SUCCESS_INVITE_MORE: "Invite more people",
    SAVE_SESSION_SUCCESS_INVITE_MORE_SHORT: "Invite people",
    SAVE_SESSION_SUCCESS_SHARE_DISABLED_HINT:
      "Sharing is available once you open the link from the email.",
    SAVE_SESSION_SUCCESS_CONTINUE: "Continue application",
    SAVE_SESSION_SUCCESS_CONTINUE_SHORT: "Continue",
    SAVE_SESSION_UPDATE_PARTICIPANTS: "Participants",
    SAVE_SESSION_UPDATE_PERSONALIZED_LINK: "Personalized link",
    SAVE_SESSION_UPDATE_PERSONALIZED_LINK_TOOLTIP:
      "The email address is already stored and does not need to be entered again when opening the application draft.",
    SAVE_SESSION_UPDATE_RECOMMENDED: "recommended",
    SAVE_SESSION_OWNER: "Owner",
    SAVE_SESSION_OWNER_INTRO:
      "You are the owner of this application draft. You can view, edit, and submit this application draft and will receive a link by email.",
    SAVE_SESSION_OWNER_EMAIL: "Owner email",
    SAVE_SESSION_OWNER_EMAIL_LABEL: "Email address",
    SAVE_SESSION_OWNER_EMAIL_HELPER:
      "Required to save. You will automatically receive the link to the application draft by email.",
    SAVE_SESSION_OWNER_NAME: "Owner name",
    SAVE_SESSION_ADD_PARTICIPANT: "Add participant",
    SAVE_SESSION_PARTICIPANT_DATE_TIME: "{date} at {time}",
    SAVE_SESSION_AUTO_TITLE_VALUE_INSURANCE: "{appName} for {value}",
    SAVE_SESSION_PERMISSION: "Permission",
    SAVE_SESSION_PARTICIPANT_EMAIL_PLACEHOLDER: "e-mail",
    SAVE_SESSION_PARTICIPANT_NAME_PLACEHOLDER: "name",
    SAVE_SESSION_NAME_LABEL: "Name",
    SAVE_SESSION_NAME_EXAMPLE_PLACEHOLDER: "e.g. Max",
    SAVE_SESSION_PERMISSION_VIEW: "View",
    SAVE_SESSION_PERMISSION_VIEW_EDIT: "View + Edit",
    SAVE_SESSION_PERMISSION_VIEW_EDIT_SUBMIT: "View + Edit + Submit",
    INVITATIO_RESUME_BOOKING_CONFIRM_KICKER: "Your quote request draft",
    INVITATIO_RESUME_BOOKING_CONFIRM_TITLE_PREFIXED:
      "Quote request draft: {title}",
    INVITATIO_RESUME_BOOKING_AUTH_ILLUSTRATION_TEXT:
      "To protect your quote request draft, we will send you a confirmation code by email.",
    INVITATIO_RESUME_BOOKING_CONFIRM_DESCRIPTION:
      "Enter the email address linked to this quote request draft. We will send a one-time code to that address for access to the quote request draft.",
    INVITATIO_RESUME_BOOKING_LOADER_ERROR_SESSION:
      "The saved quote request draft could not be loaded.",
    INVITATIO_RESUME_BOOKING_LOADER_ERROR_SESSION_NOT_FOUND:
      "The saved quote request draft could not be found or has been deleted.",
    INVITATIO_RESUME_BOOKING_LOADER_ERROR_SESSION_EXPIRED:
      "This saved quote request draft has expired.",
    INVITATIO_RESUME_BOOKING_LOADER_TITLE:
      "Your quote request draft is being prepared",
    INVITATIO_RESUME_BOOKING_LOADER_SUBTITLE:
      "Please wait while we load your saved quote request draft.",
    INVITATIO_SAVE_SESSION_COMPLETED_LINK_LABEL: "Link to quote request draft",
    INVITATIO_SAVE_SESSION_INACTIVITY_DISCLAIMER:
      "Saved quote request drafts are automatically deleted after 30 days of inactivity.",
    INVITATIO_SAVE_SESSION_NOT_TRANSMITTED:
      "The request has not yet been submitted to the responsible insurer.",
    INVITATIO_SAVE_SESSION_DRAFT_DISCLAIMER:
      "<strong>Please note:</strong> This is a saved draft of an insurance quote request. A legally binding request is only created when you submit it via the “{submitButton}” button. Saving does not create a contractual relationship. Cover only exists once <strong>{insurerName}</strong> has expressly accepted your request.",
    INVITATIO_SAVE_SESSION_SHARE_WITH_BROKER:
      "Allow {brokerName} access to my saved quote request draft",
    INVITATIO_SAVE_SESSION_NEW_INTRO:
      "Save your request as a draft. All you need is an email address so we can send you a personal link.",
    INVITATIO_SAVE_SESSION_NEW_INTRO_BROKER:
      "Save your request as a draft. Enter a title — the draft will then appear in your drafts overview in the distribution portal.",
    INVITATIO_SAVE_SESSION_NEW_INTRO_WITH_SHARING:
      "Save your request as a draft. All you need is an email address so we can send you a personal link. You can then also invite other people to your quote request draft.",
    INVITATIO_SAVE_SESSION_PARTICIPANTS_INTRO:
      "Invite other people so they can view, edit, or submit your request as a draft. Each email address can only be used once.",
    INVITATIO_SAVE_SESSION_PARTICIPANTS_HELPER:
      "All participants receive a link by email and can open the request as a draft.",
    INVITATIO_SAVE_SESSION_SHARE_WITH_BROKER_HELPER:
      "The aforementioned broker gets access to this quote request draft you have saved. You can deactivate this option at any time.",
    INVITATIO_SAVE_SESSION_MANAGE_DESCRIPTION:
      "To manage participants, permissions, or access links, open management for the request as a draft.",
    INVITATIO_SAVE_SESSION_MANAGE_TITLE: "Manage draft",
    INVITATIO_SAVE_SESSION_SHARE_TITLE: "Share draft",
    INVITATIO_SAVE_SESSION_SHARE_MENU_SHARE: "Share quote request draft",
    INVITATIO_SAVE_SESSION_SHARE_MENU_EDIT_CALCULATION:
      "Edit quote request draft",
    INVITATIO_SAVE_SESSION_EDIT_CALCULATION_TITLE: "Edit draft",
    INVITATIO_SAVE_SESSION_EDIT_CALCULATION_INTRO:
      "Update the title and note for your saved quote request draft.",
    INVITATIO_SAVE_SESSION_SAVE_TITLE: "Save draft",
    INVITATIO_SAVE_SESSION_TITLE_HELPER:
      "Choose a memorable title for your quote request draft or use a suggested one. You can change the title later.",
    INVITATIO_SAVE_SESSION_UPDATE_OWNER_LINK:
      "Owner link to quote request draft",
    INVITATIO_SAVE_SESSION_UPDATE_OWNER_LINK_HELPER:
      "The owner can use this link to open and manage the quote request draft directly.",
    INVITATIO_SAVE_SESSION_UPDATE_GENERAL_LINK:
      "General link to quote request draft",
    INVITATIO_SAVE_SESSION_UPDATE_GENERAL_LINK_HELPER:
      "Enter an email address saved with this quote request draft. We will send an email to that address — use the link in that email to open the quote request draft.",
    INVITATIO_SAVE_SESSION_UPDATE_SUCCESS_TITLE:
      "Quote request draft saved successfully",
    INVITATIO_SAVE_SESSION_UPDATE_SUCCESS_EMAIL_SENT:
      "We sent the link to the quote request draft to {emails}.",
    INVITATIO_SAVE_SESSION_UPDATE_SUCCESS_SAVED:
      "The quote request draft was saved.",
    INVITATIO_SAVE_SESSION_SUCCESS_EMAIL_SENT_LINE:
      "We sent the link to the quote request draft to {email}.",
    INVITATIO_SAVE_SESSION_SUCCESS_PORTAL_DRAFTS_LINE:
      "You can find your quote request draft in the distribution portal under {portalDraftsLink}. We sent the link to your draft to {email}.",
    INVITATIO_SAVE_SESSION_SUCCESS_CHECK_EMAIL:
      "You will receive the link to your quote request draft within a few minutes. Please check your emails and, if needed, your spam folder.",
    INVITATIO_SAVE_SESSION_SUCCESS_SHARE: "Share quote request draft",
    INVITATIO_SAVE_SESSION_SUCCESS_SHARE_DISABLED_HINT:
      "You can share your quote request draft once you open the link from the email for your quote request draft.",
    INVITATIO_SAVE_SESSION_SUCCESS_CONTINUE: "Continue request",
    INVITATIO_SAVE_SESSION_UPDATE_PERSONALIZED_LINK_TOOLTIP:
      "The email address is already stored and does not need to be entered again when opening the quote request draft.",
    INVITATIO_SAVE_SESSION_OWNER_INTRO:
      "You are the owner of this quote request draft. You can view, edit, and submit this quote request draft and will receive a link by email.",
    INVITATIO_SAVE_SESSION_OWNER_EMAIL_HELPER:
      "Required to save. You will automatically receive the link to the quote request draft by email.",
    INVITATIO_FEATURE_HIGHLIGHT_SAVE_BUTTON_TITLE: "Save quote request draft",
    INVITATIO_FEATURE_HIGHLIGHT_SAVE_BUTTON_BODY:
      "Save your request as a draft. All you need is an email address so we can send you a personal link to your quote request draft.",
    INVITATIO_UPDATE_SESSION_ERROR_DESCRIPTION:
      "The quote request draft could not be updated. Please try again.",

    SAVE_SESSION_NO_PARTICIPANTS: "No people added yet.",
    SAVE_SESSION_PARTICIPANT_TITLE: "Participant {number}",
    SAVE_SESSION_REMOVE_PARTICIPANT: "Remove participant {number}",
    SAVE_SESSION_EDIT_PARTICIPANT: "Edit participant {number}",
    SAVE_SESSION_DONE: "Done",
    SEALS_HEADING_INSURER: "Awards for this insurer",
    SEALS_HEADING_PRODUCT: "Awards for this product",
    SEALS_INDICATOR_LINK: "Awards ({count})",
    SEALS_MORE_LINK: "+ {count} more…",
    SEARCHING_MATCHING_TARIFFS: "Finding matching products…",
    SEARCH_FORM_LOADING: "Loading search form…",
    SEARCH_MASK_DISMISS_BTN_SHORT_TXT: "Adjust",
    SEARCH_MASK_DISMISS_BTN_TXT: "Edit search",
    SEARCH_MASK_DISMISS_SECONDARY_BTN_SHORT_TXT: "Continue",
    SEARCH_MASK_DISMISS_SECONDARY_BTN_TXT: "Continue with settings",
    SEARCH_MASK_ERROR:
      "Your search returned no results. Please complete all fields.",
    SEARCH_MASK_MODAL_TEXT_PART_ONE:
      "You haven’t changed any search criteria yet.",
    SEARCH_MASK_MODAL_TEXT_PART_TWO:
      "You can keep the default criteria or adjust your search to match your needs.",
    SEARCH_OFFERS: "Search products",
    SEARCH_RESULTS_APPLIED_LABEL: "Search criteria applied",
    SEARCH_RESULTS_PRINT_GENERATED: "Generated on {date}",
    SEARCH_RESULTS_PRINT_QR_ALT:
      "QR code with link to this comparison (same as when sent by email)",
    SEARCH_RESULTS_PRINT_QR_HINT: "Link to page",
    SHARE: "Share",
    TARIFF_PRINT_TITLE: "Tariff: {id} – {name}",
    TARIFF_PRINT_PREPARING: "Preparing print preview…",
    SEARCH_RESULTS_PRINT_TITLE: "Search results",
    SEND: "Send",
    SEND_EMAIL_INFO_BOLD:
      "Send this comparison by email – directly to a customer or colleague.",

    SEND_EMAIL_INFO:
      "The recipient addresses are not stored and are not shared.",
    SEND_VIA_EMAIL: "Send by email",
    SEND_VIA_EMAIL_SHORT: "Send",
    SEPA_ERROR_MESSAGE: "SEPA direct debit authorisation is required",
    SHARE_COMPARISON_EMAIL_ERROR_BODY:
      "Please check the email address or try again later.",
    SHARE_COMPARISON_EMAIL_ERROR_TITLE: "An error occurred",
    SHARE_COMPARISON_EMAIL_SUCCESS_BODY: "The link was sent to {email}.",
    SHARE_COMPARISON_EMAIL_SUCCESS_TITLE: "Email sent",
    SHARE_COMPARISON_MODAL_TITLE: "Share comparison",
    SHOW_ALL_COUNT: "Show all {count}",
    SHOW_LESS: "Show less",
    SHOW_MORE_TARIFFS: "Show more results",
    SORT: "Sort",
    SORT_BY: "Sort by:",
    PRODUCTS_FOUND: "{count} product found | {count} products found",
    PRODUCTS_FOUND_NONE: "No products found",
    SORT_TOGGLE_INSURER_HIGH: "Z",
    SORT_TOGGLE_INSURER_LOW: "A",
    SPECIAL_CONDITIONS_TEXT: "Please review the special terms",
    SPECIAL_FEATURES_AND_DEFINATIONS: "Special provisions and definitions",
    SPECIAL_FEATURES_TOOLTIP:
      "Under Notices you’ll find important product and contract information that is not part of our detailed comparison.",
    USEFUL_LINKS: "Useful informations",
    BOOKING_LINK_COUNTRY_LABEL: "Country",
    BOOKING_LINK_COUNTRY_D: "Germany",
    BOOKING_LINK_COUNTRY_AT: "Austria",
    BOOKING_LINK_COUNTRY_CH: "Switzerland",
    TARIFF_ADDONS: "Optional add-ons",
    TARIFF_ADDONS_INTRO_TEXT:
      "The following optional benefits are available for this product. You can add them on the application form. Adding benefits may change the quoted premium.",
    TARIFF_ADDONS_OVERVIEW_HEADING: "Selected add-ons",
    TARIFF_BLOCK_BOOK_INQUIRY: "Request now",
    TARIFF_BLOCK_BOOK_INQUIRY_SHORT: "Request",
    TARIFF_BLOCK_COVOMO_PLAN_SCORE: "Product score",
    TARIFF_BLOCK_COVOMO_RATING_GRADE: "Satisfactory",
    TARIFF_BLOCK_MODAL_NOTICE_TITLE: "Notice",
    TARIFF_BLOCK_PAYMENT_HEADING: "Payment options",
    TARIFF_BLOCK_PAYMENT_INTRO:
      "The following payment options are available for the selected product. The final payment method is selected in the last step of the application form.",
    TARIFF_BLOCK_PAYMENT_OPTIONS_LOADING: "Loading payment options…",
    TARIFF_BLOCK_PRICE_ON_REQUEST: "On request",
    TARIFF_BLOCK_REQUEST_QUOTE: "Request a quote",
    TARIFF_BLOCK_SUBJECT_INQUIRY_BADGE: "Inquiry required",
    TARIFF_BLOCK_SUBJECT_INQUIRY_TOOLTIP:
      "The insurer reviews this application individually. Please allow some time for a decision.",
    TARIFF_CARD_FOOTER_ADDONS: "Options",
    TARIFF_CARD_FOOTER_COMPARE: "Compare",
    TARIFF_CARD_FOOTER_DETAILS: "Details",
    TARIFF_CARD_FOOTER_NOTES: "Notes",
    TARIFF_CARD_FOOTER_PAYMENT: "Payment",
    TARIFF_COMPARISON_SHOW_DIFFERENCES_ONLY: "Differences only",
    TARIFF_COMPARISON_SHOW_PAYMENT_OPTIONS: "Show possible payment intervals",
    TARIFF_COMPARISON_SHOW_TOOLTIPS_INLINE: "Show hint texts in comparison",
    TARIFF_COMPARISON_LOADING: "Loading your comparison…",
    TARIFF_DETAILS: "Product details",
    TARIFF_MANAGER_BRAND_RATING: "{brandName} Rating: {score}",
    TARIFF_MANAGER_HOVER_SHOW_DETAILS: "Show details",
    TARIFF_MANAGER_LEGACY_ID: "ID: {id}",
    TARIFF_RIBBON_CHEAPEST_PRICE: "Lowest price",
    TAX_INCLUDED: "Incl. insurance premium tax",
    THE_FORMAT_OF: "The format of",
    TIP: "Notices",
    TIP_SHOW: "Show notices",
    TOTAL_PRICE: "Total premium",
    TO_COMPARE: "Compare products",
    TRAVELING_PEOPLE: "Travellers’ ages",
    TYPES_OF_INSURANCE: "Types of cover",
    VERIFICATION_ALREADY_VERIFIED_P1:
      "Your email address has already been confirmed. Your insurance application with reference number <strong>{bookingId}</strong> has been received successfully.",
    VERIFICATION_ALREADY_VERIFIED_P2:
      'If you have not yet received a confirmation from us by email, please check your spam folder or contact our customer service at <a href="mailto:{supportEmail}">{supportEmail}</a>.',
    VERIFICATION_ALREADY_VERIFIED_TITLE:
      "Your email address has already been confirmed",
    VERIFICATION_BOOKING_PENDING_BODY:
      "To instruct us to forward your application with reference number <strong>{bookingData}</strong> to <strong>{insurerName}</strong>, please click the <strong>“Confirm email address”</strong> link in the email we have just sent to <strong>{email}</strong>. If you do not receive an email, please check your spam folder.",
    VERIFICATION_BOOKING_PENDING_FORWARD_NOTE:
      "We will only forward your application to take out insurance once you have completed the confirmation successfully.",
    VERIFICATION_BOOKING_PENDING_TITLE: "Please confirm your email address",
    VERIFICATION_CONTACT_SUPPORT_DIRECT:
      'Please contact our customer service at <a href="mailto:{supportEmail}">{supportEmail}</a>.',
    VERIFICATION_CONTACT_SUPPORT_FOLLOWUP:
      'If the error persists, please contact our customer service at <a href="mailto:{supportEmail}">{supportEmail}</a>.',
    VERIFICATION_EMAIL_CONFIRM_EXPIRED_BODY:
      "The link to confirm your application with reference number <strong>{bookingId}</strong> is no longer valid. We will not process your application to take out insurance any further.",
    VERIFICATION_EMAIL_CONFIRM_LINK_UNKNOWN:
      "We do not recognise this email confirmation link. Please check whether a mistake occurred when opening or copying the link.",
    VERIFICATION_LINK_EXPIRED_TITLE: "This link is no longer valid",
    VERIFICATION_LINK_EXPIRY_NOTICE:
      "<strong>Please note that this link is only valid until {date} at 23:59.</strong>",
    VERIFICATION_LINK_INVALID_TITLE: "This link is invalid",
    VERIFICATION_RENEWAL_LINK_UNKNOWN:
      "We do not recognise this contract renewal link, or it is no longer valid. Please check whether a mistake occurred when opening or copying the link.",
    VERIFICATION_RELOAD_PAGE: "Reload page",
    VERIFICATION_SERVICE_UNAVAILABLE_BODY:
      "This service is currently unavailable. Please reload the page. If the problem persists, please try again later.",
    VERIFICATION_SERVICE_UNAVAILABLE_TITLE:
      "Confirmation currently unavailable",
    VERIFICATION_PRICE_UNAVAILABLE_BODY:
      "The new premium could not be determined because your application data is out of date and needs to be updated.",
    VERIFICATION_LOADING: "Checking your confirmation…",
    VERIFICATION_POLICY_START_CHANGED_TITLE:
      "Policy start date and premium have changed",
    VERIFICATION_POLICY_START_CHANGED_BODY:
      "The originally selected policy start date is no longer available for this tariff. Your application can only continue with a new policy start date and the adjusted premium.",
    VERIFICATION_POLICY_START_CHANGED_NOTE:
      "Your application will only be processed further after you confirm.",
    VERIFICATION_POLICY_START_OLD_LABEL: "Previous policy start",
    VERIFICATION_POLICY_START_NEW_LABEL: "New policy start",
    VERIFICATION_POLICY_START_OLD_PRICE_LABEL: "Previous premium",
    VERIFICATION_POLICY_START_NEW_PRICE_LABEL: "New premium",
    VERIFICATION_POLICY_START_CONFIRM_BUTTON:
      "Confirm new policy start and premium",
    VERIFICATION_POLICY_START_BOOKING_LABEL: "Application reference: ",
    VERIFICATION_SUCCESS_COVER_NOTICE:
      "<strong>Please note:</strong> We point out that cover only exists once your application to take out insurance has been accepted and confirmed by <strong>{insurerName}</strong>. Only the cover set out in the terms and conditions applies. The benefit features we display are updated to the best of our knowledge. For your insurance contract, however, solely the scope of cover stated in the terms and conditions applies.",
    VERIFICATION_SUCCESS_RECEIVED_BODY:
      "Your insurance application with reference number <strong>{bookingId}</strong> has been received successfully. You will shortly receive a confirmation email at <strong>{policyHolderEmail}</strong>. If you do not receive an email, please check your spam folder.",
    VERIFICATION_SUCCESS_THANKS: "Thank you for confirming your email address.",
    VERIFICATION_SUCCESS_TITLE: "Your application is now being processed",
    WHAT_IS_NEXT: "What happens next",
    WHAT_IS_NEXT_SUBMIT_TITLE: "Submit application",
    WHAT_IS_NEXT_SUBMIT_TEXT: "We have received your application.",
    WHAT_IS_NEXT_PROGRESS_EMAIL_VALIDATION_TEXT:
      "Please confirm your email using the link in our message.",
    WHAT_IS_NEXT_PROGRESS_SUBMISSION_TEXT:
      "We review your application and forward it.",
    WHAT_IS_NEXT_PROGRESS_PROCESSING_TEXT:
      "The insurer processes your application.",
    WHAT_IS_NEXT_PROGRESS_INSURANCE_POLICY_TEXT:
      "The insurer sends you the policy documents.",
    WHAT_IS_NEXT_EMAIL_VALIDATION_TITLE: "Confirm email",
    WHAT_IS_NEXT_EMAIL_VALIDATION_TEXT:
      "Please confirm your email address using the link in the email we sent to <strong>{email}</strong>. Only then can we forward your application.",
    WHAT_DOES_IT_MEAN: "What does this mean?",
    WIZARD_SELECT_PLACEHOLDER: "Please choose…",
    WIZARD_FORM_COMPLETE_TOAST: "Please complete the form in full.",
    SBS_INTRO_HEADLINE: "In a few steps to {calculatorName}",
    SBS_INTRO_HEADLINE_FALLBACK: "In a few steps to your quote",
    SBS_INTRO_LEAD:
      "Answer the following questions – we’ll show matching tariffs for you to compare.",
    SBS_INTRO_BEFORE_START: "Before you start",
    SBS_INTRO_LEGAL_HINT: "Please note our legal information:",
    SBS_INTRO_LEGAL_ACCORDION:
      "If you would like to enter personal data of other persons",
    SBS_INTRO_THIRD_PARTY_DATA_NOTICE:
      "If you enter data relating to other people, please ensure that they (or their legal representatives) consent to this. Also provide the data subjects with our privacy policy.",
    SBS_INTRO_CTA: "Get started",
    SBS_BACK: "Back",
    SBS_PROGRESS: "{percent} %",
    SBS_DATA_PROCESSING: "Information on data processing can be found {link}.",
    SBS_DATA_PROCESSING_LINK: "here",
    SBS_OPEN_CALENDAR: "Open calendar",
    SBS_DESIRED_START_DATE: "Preferred start date",
    WIZARD_INITIAL_INFO_CHECKBOX_TEXT:
      "I confirm that I have downloaded and read the initial disclosure for insurance intermediaries pursuant to § 15 VersVermV.",
    WIZARD_INITIAL_INFO_REQUIRED:
      "Please confirm receipt of the initial disclosure.",
    WIZARD_SUMMARY_EDIT: "Edit",
    WIZARD_SUMMARY_TITLE: "Your search",
    UI_DISPLAY: "Display",
    UI_DISPLAY_CURRENT: "Display: {setting}",
    UI_THEME_CYCLE_TO: "Switch color scheme to {mode}",
    UI_THEME_LIGHT: "Light",
    UI_THEME_DARK: "Dark",
    UI_THEME_AUTO: "Automatic",
    UI_THEME_HIGH_CONTRAST_ENABLE: "High contrast",
    UI_THEME_HIGH_CONTRAST_DISABLE: "Standard contrast",
    UI_CONTRAST_TOGGLE_TO: "Switch contrast to {mode}",
    UI_FONT_SIZE_LEVEL_0: "Standard",
    UI_FONT_SIZE_LEVEL_1: "Enlarged",
    UI_FONT_SIZE_LEVEL_2: "Maximum",
    UI_FONT_SIZE_CYCLE_TO: "Switch font size to {size}",
    UI_LOADING: "Loading…",
    UI_FONT_SIZE_INCREASE: "Increase font size",
    UI_FONT_SIZE_DECREASE: "Decrease font size",
    UPDATE_SESSION_SUCCESS_DESCRIPTION: "Your changes have been saved.",
    UPDATE_SESSION_SUCCESS_TITLE: "Changes saved",
    UPDATE_SESSION_ERROR_DESCRIPTION:
      "The application draft could not be updated. Please try again.",
    CONTACT_WIDGET_DROPDOWN_TITLE: "Your contacts",
    LIVE_CHAT_OPEN_LABEL: "Open live chat",
    CONTACT_WIDGET_TOGGLE_LABEL: "Show or hide contact information",
    CONTACT_WIDGET_EMAIL_LABEL: "Email",
    CONTACT_WIDGET_PHONE_LABEL: "Phone",
    CONTACT_WIDGET_PHOTO_ALT: "Contact photo",
    CONTACT_WIDGET_WEBSITE_LABEL: "Website",
    YOUR_CONTACT_PERSON: "Your contact",
    YOUR_CONTRACT_NUM: "Your application",
    YOUR_DOCUMENTS: "Your documents",
    YOUR_RECORDS: "Your documents",
    YOUR_SELECTION: "Your selection",
    YOUR_SEARCH_SELECTION: "Your search selection",
    MCP_WIDGET_BEST_OFFERS: "Best offers",
    MCP_WIDGET_BOOK: "Book with {brandName}",
    MCP_WIDGET_BOOK_MESSAGE:
      "I would like to book the tariff {tariff} from {insurer}.",
    MCP_WIDGET_DETAILS: "Details",
    MCP_WIDGET_PRICE_ON_REQUEST: "Price on request",
    MCP_WIDGET_ALL_SET: "All details have been captured",
    MCP_WIDGET_OPEN_SUMMARY: "Continue on {brandName}",
    MCP_WIDGET_IMPORTANT: "Important",
    MCP_WIDGET_CHECK_NOTICE:
      "Please check all details again on {brandName} before completing. They are the basis of your insurance cover – wrong or incomplete details can endanger it.",
    MCP_WIDGET_CODE_NOTICE:
      "To open it, we send you a confirmation code by email.",
  },
};
